const registrationPetDetails = {
	state: {
		petDetails: {
			name: '',
			breedId: '',
			breedSize: '',
			breedName: '',
			birthdate: '',
			gender: '',
			petImageUpload: '',
			role: 1
		},
		imageSrc: '',
		registrationUserDetails: {
			profileImageUpload: ''
		},
		profileImageSrc: '',
		breeds: [],
		geoLocation: {}
	},
	mutations: {
		setAddPetDetails(state, petDetails) {
			state.petDetails = petDetails;
		},
		clearAddPetDetails(state){
			state.petDetails.name = '';
			state.petDetails.breedId = '';
			state.petDetails.birthdate = '';
			state.petDetails.gender = '';
			state.petDetails.petImageUpload = '';
			state.petDetails.role = 1;
			state.imageSrc = '';
			state.registrationUserDetails.profileImageUpload = '';
			state.profileImageSrc = '';
			state.breeds = [];
			state.petDetails.breedSize = '';
			state.petDetails.breedName = '';
		},
		setImageSrc(state, src) {
			state.imageSrc = src;
		},
		setProfileImageSrc(state, src) {
			state.profileImageSrc = src;
		},
		setBreedLists(state, breeds) {
			state.breeds = breeds;
		},
		setRegistrationUserDetails(state, userDetails) {
			state.registrationUserDetails = userDetails;
		},
		setGeoLocation(state, geoLocation) {
			state.geoLocation = geoLocation;
		}
	},
	getters: {
		getAddPetDetails(state) {
			return state.petDetails;
		},
		getBreedLists(state) {
			return state.breeds;
		},
		getRegistrationUserDetails(state) {
			return state.registrationUserDetails
		},
		getGeoLocation(state) {
			return state.geoLocation;
		}
	}
}

export default registrationPetDetails;